import ApiService from "../../services/api";
import mapRealtime from "./map.vue";
import fleetStatusChart from "./charts/fleetStatus.vue";
import alarmsChart from "./charts/alarms.vue";
import kmTraveledChart from "./charts/kmtraveled.vue";
import avgConsumptionChart from "./charts/avgConsumption.vue";
import driveIdleTimeChart from "./charts/driveIdleTime.vue";
import co2EmittedChart from "./charts/co2Emitted.vue";
import { bus } from "../../main";
import helpers from "../../shared/fleetbox-helpers";
import { mapGetters } from "vuex";

export default {
	components: {
		mapRealtime,
		fleetStatusChart,
		alarmsChart,
		kmTraveledChart,
		avgConsumptionChart,
		driveIdleTimeChart,
		co2EmittedChart
	},
	data: function() {
		return {
			//#region filters
			vehicleIdFilterField: "number_plate",
			pollingTime: 300, //s
			vehicles: [],
			vehiclesSelected: [],

			drivers: [],
			driversSelected: [],

			showStopVehicle: true,
			showIdleVehicle: true,
			showRunVehicle: true,

			categories: [],

			showDiagnosticChart: true,

			itemVehicleTemplate: "<div style='height: 30px'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",
			tagVehicleTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",

			itemDriverTemplate: "<div style='height: 30px'>#= surname # #= name # <br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",
			tagDriverTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= surname # #= name # <br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",
			//#endregion

			//#region Real time Map
			mapConfig: {
				mapInitialLocation: {
					lat: 43.1107,
					lng: 12.3908
				}
			},
			items: [],
			vehicleHistoryPosition: [],

			seeDashboardFleerun: true
			//#endregion
		};
	},
	watch: {},
	created() {
		if (this.roles && this.roles.length > 0) {
			var findSettingsShowDashboard = this.roles.find(item => {
				return item.see_dashboard_fleerun == null || item.see_dashboard_fleerun == true;
			});

			if (!findSettingsShowDashboard) {
				findSettingsShowDashboard = this.roles.find(item => {
					return item.see_dashboard_fleerun === false;
				});

				if (findSettingsShowDashboard) {
					this.seeDashboardFleerun = false;
				}
			}
		}

		if (this.seeDashboardFleerun) {
			if (this.settings && this.settings.geoLocation.refreshInterval) {
				this.pollingTime = this.settings.geoLocation.refreshInterval;
			}

			this.vehicleIdFilterField = this.settings.vehicleIdFilterField;

			// this.showDiagnosticChart = this.scopes.some(function(item) {
			// 	return item == "TRIPS_DIAGNOSTIC_DATA";
			// });

			//#region filters
			this.getCategoriesData();
			this.getAllVehicles();
			this.getAllDrivers();
			//#endregion

			//#region Real time Map
			this.pollData();
			//#endregion

			bus.$emit("show-spinner-loading");
		}
	},
	beforeDestroy() {
		clearInterval(this.polling);
	},
	methods: {
		//#region filters
		onShowRunVehicle() {
			this.showRunVehicle = !this.showRunVehicle;
		},
		onShowIdleVehicle() {
			this.showIdleVehicle = !this.showIdleVehicle;
		},
		onShowStopVehicle() {
			this.showStopVehicle = !this.showStopVehicle;
		},
		applyFilter() {
			this.updateVisibilityItemsByHeadFilter();
		},
		resetFilter() {
			this.vehiclesSelected = [];
			this.driversSelected = [];
			this.showStopVehicle = true;
			this.showIdleVehicle = true;
			this.showRunVehicle = true;
			this.updateVisibilityItemsByHeadFilter();
		},
		onVehicleDriverFilterSelected(e) {
			if (e.indices[0] === 0) {
				//vehicle select
				this.isDriverFilterSelected = false;
				this.isVehicleFilterSelected = true;
				this.driversSelected = [];
			} else {
				//driver select
				this.isVehicleFilterSelected = false;
				this.isDriverFilterSelected = true;
				this.vehiclesSelected = [];
			}
		},
		startDateChange(item) {
			var newStartDate = moment(item.sender.value());
			if (newStartDate > moment(this.endDate)) {
				this.endDate = newStartDate;
			}
			this.startDate = newStartDate;
			//this.getData();
		},

		endDateChange(item) {
			var newEndDate = moment(item.sender.value());
			if (newEndDate < moment(this.startDate)) {
				this.startDate = newEndDate;
			}
			this.endDate = newEndDate;

			//this.getData();
		},

		filterPlateChange(e) {
			this.vehiclesSelected = e.sender.value();
			//this.updateVisibilityItemsByHeadFilter();
		},
		filterDriverChange(e) {
			this.driversSelected = e.sender.value();
			//this.updateVisibilityItemsByHeadFilter();
		},

		getAllVehicles: function() {
			var self = this;
			ApiService.getVehiclesLookup({ page: 0, pageSize: 1000000 }, this.vehicleIdFilterField).then(res => {
				self.vehicles = res.items
					.filter(vh => {
						return vh.box_active;
					})
					.map(function(vehicle) {
						return {
							id: vehicle.number_plate,
							name: vehicle.name,
							number_plate: vehicle.number_plate,
							name_numberplate: `${vehicle.number_plate} ${vehicle.name}`
						};
					});

				self.vehicles = self._.sortBy(self.vehicles, function(item) {
					return item.number_plate.toLowerCase();
				});
			});
		},
		getAllDrivers() {
			var self = this;
			ApiService.getDriversData({ page: 0, pageSize: 100000, onlyActiveWithBox: true }, true).then(res => {
				self.drivers = res.items.map(function(driver) {
					return {
						id: `${driver.surname ? driver.surname.toLowerCase() : ""} ${driver.name ? driver.name.toLowerCase() : ""}`,
						name: driver.name ? driver.name.toLowerCase() : "",
						surname: driver.surname ? driver.surname.toLowerCase() : "",
						name_surname_fiscalcode: `${driver.name} ${driver.surname} ${driver.fiscal_code}`,
						fiscal_code: driver.fiscal_code
					};
				});

				self.drivers = self._.sortBy(self.drivers, ["surname", "name"]);

				self.drivers.unshift({
					id: "nd",
					name: "NON DISPONIBILE",
					surname: "",
					fiscal_code: ""
				});
			});
		},
		getCategoriesData() {
			var self = this;
			ApiService.getCategoriesData().then(res => {
				self.categories = res.map(function(item) {
					return {
						id: item.id,
						box_drive_icon: item.box_drive_icon,
						box_stop_icon: item.box_stop_icon,
						box_still_icon: item.box_still_icon
					};
				});
				self.getData();
			});
		},

		updateVisibilityItemsByHeadFilter() {
			var self = this;

			let verifyVehicleSelectedFunction = null;

			if (self.vehicleIdFilterField == "code") {
				verifyVehicleSelectedFunction = function(item) {
					return _.some(self.vehiclesSelected, f => {
						return f == item.code;
					});
				};
			} else {
				verifyVehicleSelectedFunction = function(item) {
					return _.some(self.vehiclesSelected, f => {
						return f == item.number_plate;
					});
				};
			}

			this.items.forEach(item => {
				var isFilteredByPlate = false;
				isFilteredByPlate = verifyVehicleSelectedFunction(item);

				var isFilteredByDriver = _.some(self.driversSelected, f => {
					return f == item.driver_name;
				});

				if (
					(self.vehiclesSelected.length == 0 || isFilteredByPlate) &&
					(self.driversSelected.length == 0 || isFilteredByDriver) &&
					((this.showStopVehicle && item.status == "off") || (this.showIdleVehicle && item.status == "stop") || (this.showRunVehicle && item.status == "active"))
				)
					item.visible = true;
				else item.visible = false;
			});

			bus.$emit("on-filter-changed");
		},
		//#endregion

		//#region Real time Map
		pollData() {
			var self = this;
			this.polling = setInterval(() => {
				self.getData();
			}, this.pollingTime * 1000);
		},
		getData: function() {
			var self = this;
			this.loading = true;

			ApiService.getRealtimeGeolocation()
				.then(res => {
					self.items = res
						.filter(function(item) {
							return item.last_privacy_mode == false && item.box_active;
						})
						.map(function(item) {
							return {
								create_date: item.create_date,
								current_position: item.current_position,
								status: item.status,
								statusFriendly: self.getUserFriendlyStatus(item.status),
								driver_id: item.driver_id,
								driver_name: item.driver_name ? item.driver_name.toLowerCase() : "",
								mobile_phone_number: item.mobile_phone_number,
								icon: self.getIconFromCategories(item.category_id, item.status, item.last_privacy_mode, item.box_active),
								id: item.id,
								last_event_date: item.last_event_date,
								number_plate: item.number_plate,
								code: item.vehicle_code,
								update_date: item.update_date,
								vehicle_id: item.vehicle_id,
								vehicle_name: item.vehicle_name,
								last_odometer_km_value: item.last_odometer_km_value || item.last_odometer_km_value == 0 ? kendo.toString(item.last_odometer_km_value, "n2") : "",
								last_odometer_lt_value: item.last_odometer_lt_value || item.last_odometer_lt_value == 0 ? kendo.toString(item.last_odometer_lt_value, "n2") : "",
								status_date: item.status_date,
								last_speed: item.last_speed || item.last_speed == 0 ? kendo.toString(item.last_speed, "n2") : "",
								type: item.type,

								visible: self.isItemVisible(item.id),
								formattedCoordinates: self.formattedCoordinates(item.current_position),
								address: ""
							};
						});

					//self.updateVisibilityItemsByHeadFilter();

					bus.$emit("updated-data");

					//self.setAddress();
				})
				.finally(() => {
					bus.$emit("hide-spinner-loading");
				});
		},
		setAddress(itemId, showTooltip) {
			var self = this;
			//for (var i = 0; i < self.items.length; i++) {
			var item = self.items.find(function(x) {
				return x.id == itemId;
			});

			if (item) {
				var historyItemPosition = self.vehicleHistoryPosition.find(v => {
					return v.number_plate == item.number_plate;
				});

				if (
					(self._.isNull(historyItemPosition) ||
						self._.isUndefined(historyItemPosition) ||
						historyItemPosition.lat != item.current_position.lat ||
						historyItemPosition.lon != item.current_position.lon) &&
					item.current_position
				) {
					var params = {
						latitude: item.current_position.lat,
						longitude: item.current_position.lon
					};

					var getAddress = function(item, params) {
						ApiService.getReverseGeocoding(params).then(res => {
							var itemToUpdate = item;
							if (res && res.length > 0) {
								var newAddress = self._.find(res, function(item) {
									return (
										self._.find(item.types, function(x) {
											return x === "streetAddress";
										}) != null
									);
								});

								if (!newAddress) {
									newAddress = res[0];
								}

								if (self._.isNull(historyItemPosition) || self._.isUndefined(historyItemPosition)) {
									self.vehicleHistoryPosition.push({
										number_plate: itemToUpdate.number_plate,
										lat: itemToUpdate.current_position.lat,
										lon: itemToUpdate.current_position.lon
									});
								} else {
									historyItemPosition.lat = itemToUpdate.current_position.lat;
									historyItemPosition.lon = itemToUpdate.current_position.lon;
								}
								var address = "";
								if (newAddress && newAddress.formattedAddress) {
									address = newAddress.formattedAddress;
								}
								itemToUpdate.address = address;
							}

							if (showTooltip) {
								self.$nextTick(function() {
									showTooltip();
								});
							}
						});
					};

					getAddress(item, params);
				} else {
					if (showTooltip) {
						self.$nextTick(function() {
							showTooltip();
						});
					}
				}
			}
			//}
		},
		formattedCoordinates(current_position) {
			if (current_position && current_position.lat && current_position.lon)
				return helpers.formatCoordinate(current_position.lat, "lat") + ", " + helpers.formatCoordinate(current_position.lon, "lon");

			return null;
		},
		getUserFriendlyStatus(status) {
			switch (status) {
				case "off":
					return "fermo";
					break;
				case "stop":
					return "inattivo";
					break;
				case "active":
					return "movimento";
					break;
				default:
					return "sconociuto";
					break;
			}
		},
		isItemVisible(idItem) {
			if (this.items) {
				var item = this._.find(this.items, function(x) {
					return x.id == idItem;
				});
				if (item && !item.visible) {
					return false;
				}
			}

			return true;
		},
		getIconFromCategories(categoryId, status, lastPrivacyMode, box_active) {
			if (lastPrivacyMode) {
				return "/assets/map/icon/privacy_mod.png";
			}

			if (!box_active) {
				return "/assets/map/icon/blank.png";
			}

			var cat = this.categories.find(function(c) {
				return c.id == categoryId;
			});

			var icon = "";

			if (cat) {
				switch (status) {
					case "off":
						if (cat.box_stop_icon) icon = cat.box_stop_icon;
						break;
					case "stop":
						if (cat.box_still_icon) icon = cat.box_still_icon;
						break;
					case "active":
						if (cat.box_drive_icon) icon = cat.box_drive_icon;
						break;
					default:
						break;
				}
			}

			return icon || "/assets/map/icon/blank.png";
		}
		//#endregion
	},
	computed: {
		...mapGetters(["settings", "scopes", "roles"])
	}
};
